module.exports = __webpack_public_path__ + "media/images/pc/specials/common/event_detail_consultation-1954a37593857ffb0212d26293558fd4.jpg";